module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c3",
    attrs: {
      "id": "calibre_pb_2",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "western1",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("I’d like to thank my Beta readers, Tom M. and Pam O.\nEven though I can’t use your reviews, your insight, opinion and\ncritique mean everything to me.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("The ladies on my Women’s Group have been key to\nkeeping me going and keeping me writing. Ladies, your encouragement\nis priceless.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Thank you to my son Eric, who has kept me straight\nand honest with everything military. Your twenty plus years\ndedication to Uncle Sam makes me so very, very proud.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("And a big thank you to my other son, Jason, who has\nhelped with all my construction concerns and for putting up with my\nwild ideas on what and how something could be built with very\nlittle.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("I could never forget to thank Felicia Sullivan, my\neditor, for straightening out some of my more chaotic thoughts and\nfor smoothing the rough edges of this story.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("And last, but not least, thank you to my readers.\nWithout your continued support, I wouldn’t be writing yet another\nglimpse into the life of Allexa Smeth. Book #4 is coming!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2884b40a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue
// module id = 69
// module chunks = 0